export default function magnify(){
    $(document).ready(function() {
        $(".zoom").magnify();
    });
}